import {handleActions} from 'redux-actions';
import * as actions from './actions';

export interface IStickersShowState {
    stickerForAttach: any;
    password: string;
    formErrors: any;
    isStickerConfigured: boolean;
    comments: any[];
    unreadCommentsCount: number;
    showPasswordModal: boolean;
    showAttachSuccessModal: boolean;
    showScanCongratulations: boolean;
    isAttachingModalClose: boolean;
    isAttaching: boolean;
    isStickerAttached: boolean;
    showAttachingModal: boolean;
    showCongratulation: boolean;
}


const defaultState: IStickersShowState = {
    stickerForAttach: null,
    password: '',
    formErrors: {},
    isStickerConfigured: false,
    comments: [],
    unreadCommentsCount: 0,
    showPasswordModal: false,
    showAttachSuccessModal: false,
    showScanCongratulations: false,
    isAttachingModalClose: false,
    isAttaching: false,
    isStickerAttached: false,
    showAttachingModal: false,
    showCongratulation: false,

};

const reducer = handleActions(
    new Map([
        [actions.setAttachingStickerAfterLogin,
            (state, action) => ({...state, stickerForAttach: action.payload})],
        // errors
        [actions.setFormErrors,
            (state, action) => {
                return {
                    ...state,
                    formErrors: action.payload
                }
            }],
        // password modal
        [actions.setPasswordModalVisibility,
            (state, action) => {
                return {
                    ...state,
                    showPasswordModal: action.payload
                }
            }],

        // attach modal
        [actions.setAttachModalVisibility,
            (state, action) => {
                return {
                    ...state,
                    showAttachingModal: action.payload
                }
            }],
        // congratulations
        [actions.setScanCongratulationsVisibility,
            (state, action) => {
                return {
                    ...state,
                    showScanCongratulations: action.payload
                }
            }],
        // attach success modal
        [actions.setAttachSuccessModalVisibility,
            (state, action) => {
                return {
                    ...state,
                    showAttachSuccessModal: action.payload
                }
            }],

        // sticker attach
        [actions.stickerAttachRequest,
            (state, action) => {
                return {
                    ...state,
                    isAttaching: true
                };
            }],

        [actions.stickerAttachSuccess,
            (state, action) => {
                return {
                    ...state,
                    isAttaching: false,
                    isStickerAttached: true,
                    showAttachSuccessModal: true,
                    isAttachingModalClose: false,
                };
            }],
        [actions.stickerAttachFailed,
            (state, action) => {
                return {
                    ...state,
                    isAttaching: false
                };
            }],
        [actions.setAttachModalClosedFlag,
            (state, action) => {
                return {
                    ...state,
                    isAttachingModalClose: action.payload
                }
            }],

        // password
        [actions.setPassword,
            (state, action) => {
                return {
                    ...state,
                    password: action.payload
                }
            }],

        // comments load
        // nothing
        // [actions.commentsLoadRequest,
        //   (state, action) => {}],
        // [actions.commentsLoadFailed,
        //   (state, action) => {}],
        [actions.commentsLoadSuccess,
            (state, action) => {
                const {comments, unreadCommentsCount} = action.payload;
                return {
                    ...state,
                    comments,
                    unreadCommentsCount
                }
            }],
        [actions.resetFormErrors,
            (state, action) => {
                return {
                    ...state,
                    formErrors: {},
                };
            }],
        [actions.stickerShowCongratulation,
            (state, action) => {
                return {
                    ...state,
                    showCongratulation: action.payload
                };
            }]
    ]),
    defaultState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/sticker-show/reducer.ts